module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAAXNSR0IArs4c6QAAALpJREFUSEvt1DEKAjEQBdCfj5WoJ9DGwsLCG9h6TluPY2Fh6xVEZUHmy0jq3Z1ls2yxqQKBeeRPJgkDrDSAgQkJpTyquNYppYukIwALXQNo3fgNyQeAyswWAL4RKBLXgeTVgQxVbaEI4jX3JG8emZktAbzbQFHEa+5I3n1jZisAzyaoC+I1txma5ehedVAfyBzAp2+keFzFG1/8Cf+HUVIlqdgw+rdylnQq+a00jULtedcnHEInZHxx/QCk5EUZRMs65AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/more1.png
// module id = 4KCe
// module chunks = 26